<template>
  <div>
    <el-select
      v-model="areaCompany"
     
      size="mini"
      placeholder="大区"
      style="width: 140px"
      @change="getProvinceCompany($event)"
    >
      <el-option
        v-for="(item, index) in areaCompanyMap"
        :key="index"
        :label="item"
        :value="index"
      >
      </el-option>
    </el-select>
    <el-select
      v-model="provinceBranchCompany"
      size="mini"
      placeholder="省区/分公司"
      style="width: 160px"
      @change="getDealerCompany"
    >
      <el-option
        v-for="(item, index) in provinceBranchCompanyMap"
        :key="index"
        :label="item"
        :value="index"
      >
      </el-option>
    </el-select>
    <el-select
      v-model="productModelType"
      size="mini"
      placeholder="冷柜系列"
      style="width: 140px"
    >
      <el-option
        v-for="(item, index) in productModelTypeSet"
        :key="index"
        :label="item"
        :value="index"
      >
      </el-option>
    </el-select>
    <el-select
      v-model="channelType"
      size="mini"
      placeholder="渠道类型"
      style="width: 160px"
      @change="getSecond"
    >
      <el-option
        v-for="(item, index) in channelTypeMap"
        :key="index"
        :label="item"
        :value="index"
      >
      </el-option>
    </el-select>
    <el-select
      v-model="secondChannelType"
      size="mini"
      placeholder="二级渠道"
      style="width: 140px"
      @change="getThird"
    >
      <el-option
        v-for="(item, index) in secondChannelTypeMap"
        :key="index"
        :label="item"
        :value="index"
      >
      </el-option>
    </el-select>
    <el-select
      v-model="thirdChannelType"
      size="mini"
      placeholder="三级渠道"
      style="width: 160px"
    >
      <el-option
        v-for="(item, index) in thirdChannelTypeMap"
        :key="index"
        :label="item"
        :value="index"
      >
      </el-option>
    </el-select>
    <el-select
      v-model="marketType"
      size="mini"
      placeholder="市场类型"
      style="width: 140px"
    >
      <el-option
        v-for="(item, index) in marketTypeMap"
        :key="index"
        :label="item"
        :value="index"
      >
      </el-option>
    </el-select>
    <el-select
      v-model="dealerCompany"
      size="mini"
      placeholder="经销商名称"
      style="width: 160px"
    >
      <el-option
        v-for="(item, index) in dealerCompanyMap"
        :key="index"
        :label="item"
        :value="index"
      >
      </el-option>
    </el-select>
    <el-select
      v-model="store"
      size="mini"
      placeholder="网点名称"
      style="width: 140px"
    >
      <el-option
        v-for="(item, index) in storeMap"
        :key="index"
        :label="item"
        :value="index"
      >
      </el-option>
    </el-select>
    <el-select
      v-model="agencyType"
      size="mini"
      placeholder="客户类型"
      style="width: 160px"
    >
      <el-option
        v-for="(item, index) in agencyTypeMap"
        :key="index"
        :label="item"
        :value="index"
      >
      </el-option>
    </el-select>
    <el-select
      v-model="province"
      size="mini"
      placeholder="省份"
      style="width: 160px"
      @change="getCity"
    >
      <el-option
        v-for="(item, index) in provinceMap"
        :key="index"
        :label="item"
        :value="index"
      >
      </el-option>
    </el-select>
    <el-select
      v-model="city"
      size="mini"
      placeholder="城市"
      style="width: 160px"
    >
      <el-option
        v-for="(item, index) in cityMap"
        :key="index"
        :label="item"
        :value="index"
      >
      </el-option>
    </el-select>
    <el-select
      v-model="putPolicy"
      size="mini"
      placeholder="投放政策"
      style="width: 160px"
    >
      <el-option
        v-for="(item, index) in putPolicyMap"
        :key="index"
        :label="item"
        :value="index"
      >
      </el-option>
    </el-select >

    <el-select 
      v-model="year"
      size="mini"
      placeholder="投放年份"
      style="width: 160px">
      <el-option 
      v-for="(item, index) in years"
      :key="index"
      :label="item"
      :value="index">

      </el-option>
    </el-select>
    <el-input
      v-model="search"
      style="width:200px"
      size="mini"
      placeholder="请输入搜索内容"
      clearable
      @keyup.enter.native="searchCompen"
    ></el-input>
    <el-button @click="searchCompen" size="mini" type="primary">搜索</el-button>
    <el-button
      @click="resetCompen"
      size="mini"
      type="warning"
      title="清空所有筛选条件"
      >重置</el-button
    >
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: "deviceSearchBox",
  props: {
    postParams: Object
  },
  data() {
    return {
      sunPostParams: this.postParams,
      areaCompanyMap: [],
      provinceBranchCompanyMap: [],
      productModelTypeSet: [],
      agencyTypeMap: [],
      channelTypeMap: [],
      secondChannelTypeMap: [],
      thirdChannelTypeMap: [],
      dealerCompanyMap: [],
      cityMap: [],
      marketTypeMap: [],
      provinceMap: [],
      putPolicyMap: [],
      storeMap: [],
      areaCompany: "",
      provinceBranchCompany: "",
      productModelType: "",
      agencyType: "",
      channelType: "",
      secondChannelType: "",
      thirdChannelType: "",
      dealerCompany: "",
      city: "",
      marketType: "",
      province: "",
      putPolicy: "",
      store: "",
      search: "",
      years:[],
      year:'',
      areaCompanyName:'',//大区名称
      channelName:'',//渠道类型
    };
  },
  mounted() {
    this.initMap();
    if (JSON.stringify(this.$route.params) != JSON.stringify({})) {
      this.channelType = String(this.$route.params.channelType);
    };
    this.getNowYears()
  },
  methods: {
    // 投放年份函数
    getNowYears(){
      var data = new Date()
      var nowYears =  data.getFullYear() + 1;
      this.years = [...Array(Number(nowYears) - 2020).keys()].map(item => 2020 + item)
      console.log(this.years);
    },
    initMap() {
      this.$ajax
        .post("/data/getBigDataIndex_dict", { type: "areaCompanyMap" })
        .then(res => {
          console.log(res, "================--------------00");
          this.areaCompanyMap = res.data.data.areaCompanyMap;
          this.productModelTypeSet = res.data.data.productModelTypeSet;
          this.agencyTypeMap = res.data.data.agencyTypeMap;
          this.channelTypeMap = res.data.data.channelTypeMap;
          this.dealerCompanyMap = res.data.data.dealerCompanyMap;
          this.marketTypeMap = res.data.data.marketTypeMap;
          this.provinceMap = res.data.data.provinceMap;
          this.putPolicyMap = res.data.data.putPolicyMap;
          this.storeMap = res.data.data.storeMap;
          // console.log(this.$route.path)
          if (this.$route.path === "/devicesStart") {
            this.$emit("getGroup", res.data.data.groupMap);
          }
        })
        .catch(err => {
          this.$message.error("网络异常");
        });
    },
    searchCompen() {
    
      this.sunPostParams.areaCompanyName = this.areaCompanyName
      this.sunPostParams.channelName = this.channelName
      this.sunPostParams.areaCompanyId = this.areaCompany;
      this.sunPostParams.provinceBranchCompanyId = this.provinceBranchCompany;
      this.sunPostParams.productModelType = this.productModelType;
      this.sunPostParams.agencyType = this.agencyType;
      this.sunPostParams.channelType = this.channelType;
      this.sunPostParams.secondChannelType = this.secondChannelType;
      this.sunPostParams.thirdChannelType = this.thirdChannelType;
      this.sunPostParams.dealerCompany = this.dealerCompany;
      this.sunPostParams.cityCode = this.city;
      this.sunPostParams.marketType = this.marketType;
      this.sunPostParams.provinceCode = this.province;
      this.sunPostParams.putPolicy = this.putPolicy;
      this.sunPostParams.storeId = this.store;
      this.sunPostParams.keyWord = this.search;
      this.sunPostParams.putInYear = this.years[this.year]
      this.$emit("getSearchSelect", this.sunPostParams);
    },
    resetCompen() {
      this.areaCompany = "";
      this.provinceBranchCompany = "";
      this.productModelType = "";
      this.agencyType = "";
      this.channelType = "";
      this.secondChannelType = "";
      this.thirdChannelType = "";
      this.dealerCompany = "";
      this.city = "";
      this.marketType = "";
      this.province = "";
      this.putPolicy = "";
      this.store = "";
      this.year = "";
      this.areaCompanyName = ""
      this.channelName = ""
    },
    getProvinceCompany(event) {
      
      this.areaCompanyName = this.areaCompanyMap[event]
      console.log(this.areaCompanyName ,"deviceSe");
      this.$ajax
        .post("/data/getBigDataIndex_dict", {
          type: "provinceBranchCompanyMap",
          parentId: this.areaCompany
        })
        .then(res => {
          this.provinceBranchCompany = "";
          this.provinceBranchCompanyMap =
            res.data.data.provinceBranchCompanyMap;
        })
        .catch(err => {
          this.$message.error("获取失败");
        });
    },
    getDealerCompany() {
      this.$ajax
        .post("/data/getBigDataIndex_dict", {
          type: "dealerCompanyMap",
          parentId: this.provinceBranchCompany
        })
        .then(res => {
          this.dealerCompany = "";
          this.dealerCompanyMap = res.data.data.dealerCompanyMap;
        })
        .catch(err => {
          this.$message.error("获取失败");
        });
    },
    getCity() {
      this.$ajax
        .post("/data/getBigDataIndex_dict", {
          type: "cityMap",
          parentId: this.province
        })
        .then(res => {
          this.city = "";
          this.cityMap = res.data.data.cityMap;
        })
        .catch(err => {
          this.$message.error("获取失败");
        });
    },
    getSecond(event) {
      this.channelName = this.channelTypeMap[event]
      console.log(this.channelName);
      this.$ajax
        .post("/data/getBigDataIndex_dict", {
          type: "secondChannelTypeMap",
          parentId: this.channelType
        })
        .then(res => {
          this.secondChannelType = "";
          this.secondChannelTypeMap = res.data.data.secondChannelTypeMap;
          this.thirdChannelType = "";
          this.thirdChannelTypeMap = [];
        })
        .catch(err => {
          this.$message.error("网络错误");
        });
    },
    getThird() {
      this.$ajax
        .post("/data/getBigDataIndex_dict", {
          type: "thirdChannelTypeMap",
          parentId: this.secondChannelType
        })
        .then(res => {
          this.thirdChannelType = "";
          this.thirdChannelTypeMap = res.data.data.thirdChannelTypeMap;
        })
        .catch(err => {
          this.$message.error("获取失败");
        });
    }
  }
};
</script>
<style>
.el-input.el-input--mini.el-input--suffix {
  margin-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/pages/devices/components/deviceSearchBox.vue